"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Base94 = void 0;
const uuid_1 = require("uuid");
/**
 * Base94 encoding/decoding utility for UUIDs
 * Uses printable ASCII characters (33-126) for maximum density
 * Provides lossless conversion between UUIDs and 20-character strings
 */
class Base94 {
    // Characters for base94 encoding (94 printable ASCII characters)
    static CHARS = "!\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~";
    /**
     * Encodes a UUID to a base94 string (20 chars)
     * Uses a mathematical base conversion approach for lossless encoding
     */
    static encodeUuid(uuid) {
        // Remove hyphens from UUID
        const cleanUuid = uuid.replace(/-/g, "");
        // Convert hex UUID to a BigInt
        const uuidValue = BigInt("0x" + cleanUuid);
        // Convert to base94
        let result = "";
        let value = uuidValue;
        const base = BigInt(94);
        // A UUID (128 bits) requires exactly 20 base94 characters
        // (log₉₄(2¹²⁸) ≈ 19.56, so we need 20 characters)
        while (result.length < 20) {
            const remainder = Number(value % base);
            result = this.CHARS[remainder] + result;
            value = value / base;
        }
        return result;
    }
    /**
     * Decodes a base94 string back to a UUID
     * Uses a mathematical base conversion approach for lossless decoding
     */
    static decodeToUuid(encoded) {
        if (encoded.length !== 20) {
            throw new Error(`Invalid base94 encoded UUID length: ${encoded.length}, expected 20`);
        }
        // Convert from base94 to a BigInt
        let value = BigInt(0);
        const base = BigInt(94);
        for (const char of encoded) {
            const charIndex = this.CHARS.indexOf(char);
            if (charIndex === -1) {
                throw new Error(`Invalid base94 character: ${char}`);
            }
            value = value * base + BigInt(charIndex);
        }
        // Convert to hex string, ensuring it's 32 characters (16 bytes)
        let hex = value.toString(16);
        // Pad with leading zeros if necessary
        while (hex.length < 32) {
            hex = "0" + hex;
        }
        // Format as UUID
        return `${hex.substring(0, 8)}-${hex.substring(8, 12)}-${hex.substring(12, 16)}-${hex.substring(16, 20)}-${hex.substring(20, 32)}`;
    }
    /**
     * Generate a new UUID and encode it to base94 (20 chars)
     * If a UUID is provided, it will be encoded instead of generating a new one
     *
     * @param uuid Optional UUID to encode
     * @returns A base94 encoded UUID (20 chars)
     */
    static generateShortId(uuid) {
        if (uuid) {
            return this.encodeUuid(uuid);
        }
        const newUuid = (0, uuid_1.v4)();
        return this.encodeUuid(newUuid);
    }
}
exports.Base94 = Base94;
//# sourceMappingURL=Base94.js.map